export default "__VITE_ASSET__DXAUDd17__"